import styled from 'styled-components';

export const CenteredContainer = styled.div<{ minHeight?: string }>`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: ${({ minHeight }) => minHeight ?? '10vh'};
  width: 100%;

  .ant-spin-dot {
    overflow: hidden;
  }
`;
